import { ClaimItemDTO, ClaimProposalDTO } from '@reposit/api-client';
import moment from 'moment';
import numeral from 'numeral';
import React from 'react';
import { NumberFormat } from '../../constants/number-formats';
import { truncateFilename } from '../../utils/common.utils';
import Button from '../Button';
import IdentifierValue from '../IdentifierValue';
import { Td, Tr } from '../Table';
import { A } from '../Typography';

interface IndividualItemProps {
  item: ClaimItemDTO;
  showDeletedAt: boolean;
  proposals: ClaimProposalDTO[];
  onEditClaimItem?: (claimItemId: string, currentAmount: number, description: string, itemType: string) => void;
  isUpdating?: boolean;
  isEditDisabled?: boolean;
  editDisabledReason?: string;
}

const FIRST_ROUND = 1;

const IndividualItem: React.FC<IndividualItemProps> = ({
  item,
  showDeletedAt,
  proposals,
  onEditClaimItem,
  isUpdating = false,
  isEditDisabled = false,
  editDisabledReason,
}) => {
  const firstProposal = proposals.find((p) => p.round === FIRST_ROUND);
  const itemProposal = firstProposal && firstProposal.itemProposals.find((i) => i.claimItemId === item.id);
  const amount = item.deletedAt ? item.originalAmount : itemProposal && itemProposal.amount;
  const isEditable = !!onEditClaimItem && !showDeletedAt && !item.deletedAt && amount !== undefined;

  if (!firstProposal) return null;

  return (
    <Tr key={item.id}>
      <Td>
        <IdentifierValue>{item.id}</IdentifierValue>
      </Td>
      <Td>{item.description}</Td>
      <Td>{item.type}</Td>
      <Td>{amount !== undefined ? `£${numeral(amount / 100).format(NumberFormat.THOUSANDS_PENCE)}` : '-'}</Td>
      <Td>
        {item.claimItemDocuments
          ? item.claimItemDocuments.map(({ document }) => (
              <React.Fragment key={document.id}>
                <A target="_blank" href={document.url}>
                  {truncateFilename(document.name)}
                </A>
                <br />
              </React.Fragment>
            ))
          : 'No evidence provided'}
      </Td>
      {isEditable && (
        <Td>
          <span title={!isUpdating && isEditDisabled ? editDisabledReason : undefined} style={{ display: 'inline-block' }}>
            <Button
              onClick={() => onEditClaimItem!(item.id, amount as number, item.description, item.type)}
              disabled={isUpdating || isEditDisabled}
              noArrow
              mini="true"
            >
              Modify
            </Button>
          </span>
        </Td>
      )}
      {showDeletedAt && <Td>{item.deletedAt ? moment(item.deletedAt).format('DD/MM/YYYY') : '-'}</Td>}
    </Tr>
  );
};

export default IndividualItem;
